module.exports = __webpack_public_path__ + "img/text.a1913f8f.png";